import React from 'react';
import {
  BrainCircuit,
  FileText,
  Sparkles,
  Ban,
  Rocket,
  PenTool,
} from 'lucide-react';

export function Features() {
  const features = [
    {
      icon: <span className="text-4xl">🐕</span>,
      title: "Marketing-First Approach",
      description:
        "Built by marketers who understand conversion, customer journey, and what makes content actually work - not just what sounds impressive.",
    },
    {
      icon: <Sparkles className="w-5 h-5" />,
      title: "No Prompt Engineering",
      description:
        "Stop wasting time crafting the 'perfect prompt'. Our tool knows what good content looks like. Literally done for you.",
    },
    {
      icon: <Ban className="w-5 h-5" />,
      title: "Strike List Technology",
      description: 
        "Save words, phrases and patterns you don't like. Never see 'delve into', 'in today's digital landscape', or 'unlock the potential' again.",
    },
    {
      icon: <FileText className="w-5 h-5" />,
      title: "Multi-Channel Ready",
      description:
        "Create content optimized for any platform, export to your favorite tools, and maintain consistent quality across all channels.",
    },
    {
      icon: <PenTool className="w-5 h-5" />,
      title: "Custom Writing Styles",
      description:
        "Create and save your own writing styles to make your content repeatable and exactly how you want it to sound, every single time.",
    },
    {
      icon: <span className="text-3xl">💩</span>,
      title: "Not Complete Sh*t",
      description:
        "Access industry-leading models like Claude 3.7 Sonnet and OpenAI's o1 that produce significantly higher quality content than standard AI tools.",
    },
  ];

  return (
    <section className="py-20 bg-cream">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="text-dogblue font-medium mb-2">Features</div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">What Makes Us Different</h2>
          <p className="max-w-2xl mx-auto text-gray-600">
            Our AI content writer is built specifically for marketers who want content that converts, instead of content that makes your eyes roll.
          </p>
        </div>
        
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 p-6 hover:shadow-2xl transition-all duration-300">
              <div className="relative mx-auto w-16 h-16 flex items-center justify-center mb-4">
                <div className="absolute inset-0 rounded-full bg-blue-100/70"></div>
                <div className="relative z-10 text-blue-800">
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3 text-center">{feature.title}</h3>
              <p className="text-gray-600 mx-auto text-center">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}